import React from 'react';
import { useId } from 'utilsTS/hooks';
import { StackContext } from './StackContext';

export function useStack(key: string, defaultId: string | undefined, active = false): string[] {
    const id = useId(key, defaultId);
    const { get, toggle } = React.useContext(StackContext);

    React.useEffect(() => {
        toggle(key, id, active);

        return () => {};
    }, [active, key, id, toggle]);

    React.useEffect(
        () => () => {
            toggle(key, id, false);
        },
        [key, id, toggle],
    );
    return get(key);
}
